import { useSearchParams } from 'next/navigation';
import { useMemo } from 'react';

import { useConfig, useCookies } from '@packages/utilities';
import { searchParamsToObject } from '@packages/shared';
import { useAbTest } from '@packages/abtesting';

import {
  getInspiringSearchSettingsInternal,
  getTestParticipation,
  INSPIRING_SEARCH_TEST_ID,
  INSPIRING_SEARCH_V2_TEST_ID,
} from './useInspiringSearchSettings.shared';

/**
 * Get the activation status for Inspiring Search features (client-side)
 */
export const useInspiringSearchSettings = () => {
  const config = useConfig();
  const searchParams = useSearchParams();
  const { getCookies } = useCookies();

  useAbTest(INSPIRING_SEARCH_TEST_ID);
  useAbTest(INSPIRING_SEARCH_V2_TEST_ID);

  const cookies = getCookies();

  const testParticipation = getTestParticipation(cookies);

  return useMemo(
    () =>
      getInspiringSearchSettingsInternal(
        searchParamsToObject(searchParams),
        config,
        testParticipation,
      ),
    [config, searchParams, testParticipation],
  );
};
